import { makeStyles, Snackbar } from "@material-ui/core";
import { AlertTitle } from "@material-ui/lab";
import Alert from "@material-ui/lab/Alert";
import { useDispatch, useSelector } from "react-redux";

import {hideAlertSnackbar} from '../../../reducers/uiSlice'

const useStyles = makeStyles((theme) => ({
    fontStyle: {
        fontSize: 20
    },
    alertStyle: {
        "& .MuiAlert-icon": {
            fontSize: 30
        }
    }
}))

export default function UniSnackbarAlert(props) {
    const classes = useStyles();
    const dispatch = useDispatch()
    const {alertObject, openAlertSnackbar} = useSelector(state => state.ui)

    function getDuration(){
        if(!alertObject.message || !alertObject.message.length > 0){
            return alertObject.duration
        }
        let duration = alertObject.message.length * 100
        if(duration < 2000){
            return alertObject.duration
        } else {
            return duration
        }
    }

    return (
        <Snackbar 
            anchorOrigin={alertObject.position} 
            autoHideDuration={getDuration()} 
            open={openAlertSnackbar}
            onClose={handleClose}
            {...props.other}
        >
            <Alert 
                variant="filled" 
                severity={alertObject.type} 
                onClose={handleClose}
                className={classes.alertStyle}
            >
                {
                    alertObject.title && 
                    <AlertTitle className={classes.fontStyle}>{alertObject.title}</AlertTitle>
                }
                <div className={classes.fontStyle}>
                    {alertObject.message}
                </div> 
            </Alert>
        </Snackbar>
    )

    function handleClose(){
        dispatch(hideAlertSnackbar())
    }

}